import { Controller } from "@hotwired/stimulus"
import { withReturnOrigin, currentOrigin } from "../helpers/return_origin"

// Click anywhere on the <tr> → Turbo-visit hrefValue. Skips clicks
// originating from interactive elements so users can still tick the
// row checkbox, click the name link, or interact with embedded inputs.
export default class extends Controller {
  static values = { href: String }

  initialize() { this.click = this.click.bind(this) }
  connect()    { this.element.addEventListener("click", this.click) }
  disconnect() { this.element.removeEventListener("click", this.click) }

  click(event) {
    if (event.target.closest("a, button, input, select, details, summary, label, [data-no-row-link]")) return
    if (!this.hasHrefValue) return

    // A top-level Turbo.visit breaks out of any enclosing turbo-frame (the
    // upload-detail timecards panel is one), so the detail page replaces the whole
    // window rather than rendering inside the panel. `from` is the page we leave,
    // so the detail can link back (see Cup::BackLink::Component). Captured at click
    // time so it reflects the current filter even after Turbo advanced it.
    Turbo.visit(withReturnOrigin(this.hrefValue, currentOrigin()))
  }
}
